import { CenteredCol } from '../login/Login';

export default function Support() {
  return (
    <CenteredCol>
      <h2>Need help? Please email us for support at <a href="mailto:hello@lindy.chat">hello@lindy.chat</a></h2>
    </CenteredCol>
  )
}
